import { useEffect } from 'react'

export const NOME_APP = 'Heimdall'
export const LINHA_PRODUTO = 'Sentinela GitLab'

/** Título de aba no padrão «Seção — Heimdall». */
export function tituloDaPagina(secao: string): string {
  return `${secao} — ${NOME_APP}`
}

/**
 * Define o título da aba do navegador, como o `st.set_page_config(page_title=...)`.
 * Passe `completo: true` quando o texto já é o título final (sem « — Heimdall»).
 */
export function useTituloDaPagina(secao: string, opcoes: { completo?: boolean } = {}): void {
  const titulo = opcoes.completo ? secao : tituloDaPagina(secao)
  useEffect(() => {
    document.title = titulo
  }, [titulo])
}
